"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PlacemarkerStudyArea_exports = {};
__export(PlacemarkerStudyArea_exports, {
  PlacemarkerStudyArea: () => PlacemarkerStudyArea
});
module.exports = __toCommonJS(PlacemarkerStudyArea_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
function hlaAttr(attributeId, label) {
  return (0, import_topo_map.numberAttr)({
    attributeId,
    label,
    buckets: [
      (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.quality(0.9)),
      (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.quality(0.7)),
      (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.quality(0.5)),
      (0, import_topo_map.lookupBucket)(4, import_topo_map.marker.quality(0.3)),
      (0, import_topo_map.lookupBucket)(5, import_topo_map.marker.quality(0.1))
    ]
  });
}
const PlacemarkerStudyArea = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("placemarkerStudyArea"),
  title: "Study Area",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("placemarkerStudyArea"),
      title: "Study Area",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("placemarkerStudyArea"),
        attribution: []
      }),
      defaultAttribute: "habitatOverall",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.attachmentAttr)("siteMap", "Site Map"),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Classifications",
          attributes: [
            hlaAttr("habitatOverall", "Habitat Quality Assessment (HaQA)"),
            hlaAttr("habitatComplexity", "Habitat Complexity"),
            hlaAttr("habitatConnectivity", "Habitat Connectivity"),
            hlaAttr("habitatCondition", "Habitat Condition"),
            hlaAttr("landscapeOverall", "Landscape Quality Assessment (LQA)"),
            hlaAttr("landscapeComplexity", "Landscape Complexity"),
            hlaAttr("landscapeCoherence", "Landscape Coherence"),
            hlaAttr("landscapeInterest", "Landscape Interest"),
            hlaAttr("landscapeCondition", "Landscape Condition"),
            hlaAttr("heritageOverall", "Heritage Quality Assessment (HeQA)"),
            hlaAttr("heritageComplexity", "Heritage Complexity"),
            hlaAttr("heritageCoherence", "Heritage Coherence"),
            hlaAttr("heritageInterest", "Heritage Interest"),
            hlaAttr("heritageCondition", "Heritage Condition"),
            hlaAttr("amenityOverall", "Amenity Quality Assessment (AQA)"),
            hlaAttr("amenityComplexity", "Amenity Complexity"),
            hlaAttr("amenityCoherence", "Amenity Coherence"),
            hlaAttr("amenityInterest", "Amenity Interest"),
            hlaAttr("amenityCondition", "Amenity Condition")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Indices",
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "countStudyAreaHabs",
              label: "CountStudyAreaHabs: Number of 'green' land cover types in the study area",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "accessibility",
              label: "Accessibility: Accessibility into the study area for people",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "footpaths",
              label: "Footpaths: Accessibility provided by footpaths",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "cyclePaths",
              label: "CyclePaths: Accessibility provided by cycle paths",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "wheelChairAccess",
              label: "WheelChairAccess: Accessibility available to wheelchairs",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "riverVisibility",
              label: "RiverVisibility: Visibility of the river from the study area ",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "urbanVisibility",
              label: "UrbanVisibility: Visibility of urban-industrial transport from the study area",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "visualConnectivity",
              label: "VisualConnectivity: Extent of connections from the study area laterally to fringing areas",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "humanConnectivity",
              label: "HumanConnectivity: Aggregate study area connectivity",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "recreationOpportunities",
              label: "RecreationOpportunities: Range of recreational facilities available",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "recreationCondition",
              label: "RecreationCondition: Average condition of recreational facilities",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "wilderness",
              label: "Wilderness: Presence and condition of 'wilderness' areas",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "interpretationBoards",
              label: "InterpretationBoards: Presence and condition of interpretation boards",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "formalEducation",
              label: "FormalEducation: Presence and condition of formal eduction facilities",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "education",
              label: "Education: Aggregate educational value of study area",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "areaNumPollution",
              label: "AreaNumPollution: The number of types of pollution recorded across the area",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "hygiene",
              label: "Hygiene: Presence of toilet and drinking water faciities",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "litter",
              label: "Litter: Presence of litter across the study area",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "litterDisposal",
              label: "LitterDisposal: Presence of waste disposal facilities across the study area",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "personalSafety",
              label: "PersonalSafety: Facilities and indicators of personal safety",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "economicAndSocialValue",
              label: "EconomicAndSocialValue: Potential economic value of the study area",
              buckets: "auto"
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  PlacemarkerStudyArea
});
//# sourceMappingURL=PlacemarkerStudyArea.js.map
